
const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_FCSz9dIYs",
    "aws_user_pools_web_client_id": "6p672hs2dn65juhff342c02mu3",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "peopleCountAPI",
            "endpoint": "https://tukiec7jei.execute-api.ap-northeast-1.amazonaws.com/Prod",
            "region": "ap-northeast-1"
        },
    ]

};


export default awsmobile;
